


















































import {Component, Inject, Prop, Vue, Watch} from 'vue-property-decorator';
import {MarkerInjectable, userMarker} from '@/components/common/types';
import {MAFUser} from '@/store/User/types';
import * as luxon from 'luxon';
import {DateTime} from 'luxon';
import {Getter, Mutation, State} from 'vuex-class';
import {LookupIcon, lookupIcon} from '@/store/types';
import BButton from 'buefy/src/components/button/Button.vue';
import UserMarker from '@/components/common/UserMarker.vue';
import * as _ from 'lodash';

@Component({
    components: {BButton},
})
export default class UserInfoWindow extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @Prop(MAFUser) public readonly user!: MAFUser;
    @Prop() public readonly infoWindow!: google.maps.InfoWindow;
    @Prop() public readonly funStuff!: LookupIcon[];
    @Prop() public parent!: userMarker;

    public BASE_URL: string;
    public interestOne: LookupIcon | undefined | null = null;
    public interestTwo: LookupIcon | undefined | null = null;
    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    }

    public openChat() {
        this.parent.openChatWindow(this.user);
    }

    get interests(): any[] {
        const interests: any[] = [];
        if (this.user && this.user.interests && this.funStuff) {
            this.user.interests.forEach((i) => {
                const fun = this.funStuff.find((f) => f.display === i);
                interests.push({
                    type: i,
                    display: (fun) ? fun.url : '',
                });
            });
        }
        return interests;
    }

    get age() {
        // this is on the user model but for some reason it says get type not a function error?
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!this.user.birthdate) {
            return 'No Age Set';
        }
        if (typeof this.user.birthdate === 'string') {
            birthday = DateTime.fromISO(this.user.birthdate);
        } else if (this.user.birthdate instanceof Date) {
            birthday = DateTime.fromJSDate(this.user.birthdate);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return `${diffInYears ? diffInYears.toFixed(0) : 0} Years Old`;
    }

    get genderColor() {
        if (this.user.gender === 'male') {
            return 'male';
        } else if (this.user.gender === 'female') {
            return 'female';
        } else {
            return '';
        }
    }
    get updateAvatar(): string | any {
        if (this.user.userType && this.user.userType === 'Organization') {
            return './img/organizations/profile_org.png';
        } else {
            if (this.self && this.user && this.user.avataarUrl !== '') {
                return this.user.getAvataarUrl(this.BASE_URL, true);
            }
            if (this.self && this.user && this.user.imageURL !== '') {
                return this.user.imageURL;
            }
        }
    }

    public close() {
        this.infoWindow.close();
    }
}
